import React from 'react';
import { formatMoney } from '../../util/currency';
import { displayPrice } from '../../util/configHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';

import { DAY, HOUR } from '../../transactions/transaction';

import css from './TxPriceMaybe.module.css';

const { Money } = sdkTypes;

const TxPriceMaybe = props => {
  const {
    price,
    publicData,
    validListingTypes,
    intl,
    marketplaceCurrency,
    showCurrencyMismatch = false,
    isListingTypeFreeInquiry,
  } = props;
  const { listingType, vat, days_duration, session_minutes, session_hours } = publicData || {};

  const hourUnit = intl.formatMessage({ id: 'ListingCard.hourUnit' });
  const minuteUnit = intl.formatMessage({ id: 'ListingCard.minuteUnit' });
  const hourWord = intl.formatMessage({ id: 'ListingCard.hourWord' });

  const hours = Number(session_hours ?? 1);
  const minutes = Number(session_minutes ?? 0);
  const duration =
    minutes === 0
      ? hours === 1
        ? hourWord
        : `${hours}${hourUnit}`
      : hours === 0
      ? `${minutes}${minuteUnit}`
      : `${hours}${hourUnit}${minutes}${minuteUnit}`;

  const unitType = isListingTypeFreeInquiry ? '' : publicData?.unitType;

  const foundListingTypeConfig = validListingTypes?.find(conf => conf.listingType === listingType);
  const showPrice = displayPrice(foundListingTypeConfig);
  const isPriceVariationsInUse = !!publicData?.priceVariationsEnabled;
  const hasMultiplePriceVariants = publicData?.priceVariants?.length > 1;
  const vatAmountFromPrice = (price?.amount * vat) / 100;
  const priceWithVatNumber = price?.amount + vatAmountFromPrice;
  const priceWithVat = vat ? new Money(priceWithVatNumber, marketplaceCurrency) : price;

  if (!showPrice || !price || (isPriceVariationsInUse && hasMultiplePriceVariants)) {
    return null;
  }

  return (
    <div className={css.priceContainer}>
      <p className={css.price}>{formatMoney(intl, priceWithVat)}</p>
      <div className={css.perUnit}>
        {unitType === DAY ? (
          <FormattedMessage
            id={`CheckoutPageWithInquiryProcess.${!!vat ? 'perDay' : 'perDayWithoutVAT'}`}
            values={{ days: days_duration ?? 1 }}
          />
        ) : unitType === HOUR ? (
          <FormattedMessage
            id={`OrderPanel.${!!vat ? 'perBooking' : 'perBookingWithoutVAT'}`}
            values={{ duration }}
          />
        ) : (
          <FormattedMessage
            id={`CheckoutPageWithInquiryProcess.${!!vat ? 'perUnit' : 'perUnitWithoutVAT'}`}
            values={{ unitType }}
          />
        )}
      </div>
    </div>
  );
};

export default TxPriceMaybe;
